export const LIST_VIEW_MONTH_COUNT = 3;

export enum ListRangeDirection {
  Previous = 'previous',
  Next = 'next',
}

export const shiftListUtcMonths = (date: Date, months: number) => {
  const result = new Date(date);
  const originalDay = result.getUTCDate();
  // setUTCMonth overflows when the target month is shorter (i.e. february: Nov 30 + 3 → Mar 2).
  result.setUTCDate(1);
  result.setUTCMonth(result.getUTCMonth() + months);
  const lastDayOfTargetMonth = new Date(
    Date.UTC(result.getUTCFullYear(), result.getUTCMonth() + 1, 0),
  ).getUTCDate();
  result.setUTCDate(Math.min(originalDay, lastDayOfTargetMonth));
  return result;
};

const MS_PER_UTC_DAY = 24 * 60 * 60 * 1000;

export const getListRangeDayCount = (
  inclusiveStart: Date,
  exclusiveEnd: Date,
) => {
  const start = Date.UTC(
    inclusiveStart.getUTCFullYear(),
    inclusiveStart.getUTCMonth(),
    inclusiveStart.getUTCDate(),
  );

  const end = Date.UTC(
    exclusiveEnd.getUTCFullYear(),
    exclusiveEnd.getUTCMonth(),
    exclusiveEnd.getUTCDate(),
  );

  return Math.round((end - start) / MS_PER_UTC_DAY);
};

export const getListRangeFromAnchor = (date: Date) => {
  const start = new Date(date);
  start.setUTCHours(0, 0, 0, 0);

  const exclusiveEnd = shiftListUtcMonths(start, LIST_VIEW_MONTH_COUNT);

  // Visible range is [start, exclusiveEnd). When the target month is shorter,
  // shiftListUtcMonths clamps to that month's last day (Nov 30 → Feb 28). Using
  // Feb 28 as exclusiveEnd would hide it, so advance one day (→ Mar 1).
  if (exclusiveEnd.getUTCDate() < start.getUTCDate()) {
    exclusiveEnd.setUTCDate(exclusiveEnd.getUTCDate() + 1);
  }

  return { start, exclusiveEnd };
};
